import { gettext } from '@eb/i18n';

export const CORONAVIRUS_HEADER = gettext("We're here to help");
export const CORONAVIRUS_BODY = gettext(
    'See our latest COVID-19 resources to stay safe and manage your events - for <a href="/l/coronavirus-resources-event-attendees/">attendees</a> and <a href="/l/coronavirus-resources-event-organizers/">creators</a>.',
);
